export default (type, data = null) => {
  // 埋点
  try {
    if (yoozoo) {
      let dotInfo = {
        event_type: "1",
        key_module: "gtarcade养成游戏",
        key_function: "未匹配到的埋点事件",
        value: "点击",
      };
      if (data) {
        dotInfo.extend1 = JSON.stringify(data);
      }
      switch (type) {
        // 收集
        case "collect":
          dotInfo.key_function = "首页_收集";
          break;
        // 详情框
        case "detailBox":
          dotInfo.key_function = "首页_详情框";
          break;
        // 重命名
        case "rename":
          dotInfo.key_function = "首页_重命名";
          break;
        // 喂食
        case "feed":
          dotInfo.key_function = "首页_喂食";
          break;
        // 竞技场
        case "navBattle":
          dotInfo.key_function = "首页_竞技场";
          break;
        // 怪兽
        case "navMonster":
          dotInfo.key_function = "首页_怪兽";
          break;
        // 任务
        case "navTask":
          dotInfo.key_function = "首页_任务";
          break;
        // 召唤
        case "summon":
          dotInfo.key_function = "怪兽_召唤";
          break;
        // 召唤_确认
        case "summonSubmit":
          dotInfo.key_function = "怪兽_召唤_确认";
          break;
        // 召唤_新怪兽
        case "summonNew":
          dotInfo.key_function = "怪兽_召唤_新怪兽";
          dotInfo.value = "事件发生";
          break;
        // 召唤_已有怪兽
        case "summonOld":
          dotInfo.key_function = "怪兽_召唤_已有怪兽";
          dotInfo.value = "事件发生";
          break;
        // 选择怪兽
        case "petChange":
          dotInfo.key_function = "怪兽_选择怪兽";
          break;
        // 去完成
        case "taskUrl":
          dotInfo.key_function = "任务_去完成";
          break;
        // 领取
        case "taskGet":
          dotInfo.key_function = "任务_领取";
          break;
        // 匹配对手
        case "battleMatching":
          dotInfo.key_function = "竞技场-匹配对手";
          break;
        // 排行榜领取
        case "battleFetchDayReword":
          dotInfo.key_function = "排行榜-领取";
          break;
        // 显示竞技场排行榜
        case "battleShowRank":
          dotInfo.key_function = "竞技场-排行榜";
          break;
        // 开始战斗
        case "battleStart":
          dotInfo.key_function = "选择怪兽-开始战斗";
          break;
        // 放弃战斗
        case "battleAbandon":
          dotInfo.key_function = "选择怪兽-放弃战斗";
          break;
        // 确认放弃
        case "battleAbandoned":
          dotInfo.key_function = "选择怪兽-放弃战斗-确定";
          break;
        // 跳过战斗
        case "battleSkip":
          dotInfo.key_function = "战斗-跳过战斗";
          break;
        // 新手引导切换小怪兽
        case "firstPetChangeSelect":
          dotInfo.key_function = "新手引导-切换小怪兽";
          break;
        // 2.0
        // 进入怪兽乐园界面
        case "villageEnter":
          dotInfo.key_function = "怪兽乐园-进入界面";
          break;
        // 消消乐PVP/PVE进入
        case "villageGame_start_1":
          dotInfo.key_function = "怪兽乐园-小游戏_消消乐_开始";
          break;
        // 消消乐取消按钮点击
        case "villageGame_cancel_1":
          dotInfo.key_function = "怪兽乐园-小游戏_消消乐_取消";
          break;
        // 消消乐PVP/PVE完成
        case "villageGame_finish_1":
          dotInfo.key_function = "怪兽乐园-小游戏_消消乐_完成";
          break;
        // 合成西瓜PVP/PVE进入
        case "villageGame_start_2":
          dotInfo.key_function = "怪兽乐园-小游戏_合成西瓜_开始";
          break;
        // 合成西瓜取消按钮点击
        case "villageGame_cancel_2":
          dotInfo.key_function = "怪兽乐园-小游戏_合成西瓜_取消";
          break;
        // 合成西瓜PVP/PVE完成
        case "villageGame_finish_2":
          dotInfo.key_function = "怪兽乐园-小游戏_合成西瓜_完成";
          break;
        // 模式选择弹窗
        case "village_selectModel":
          dotInfo.key_function = "怪兽乐园-选择模式";
          break;
        // 怪兽选择弹窗
        case "village_selectPet":
          dotInfo.key_function = "怪兽乐园-选择怪兽";
          break;
        // 对手选择弹窗
        case "village_selectOpponent":
          dotInfo.key_function = "怪兽乐园-选择对手";
          break;
        // 怪兽商店弹窗
        case "village_store":
          dotInfo.key_function = "怪兽乐园-查看怪兽商店";
          break;
        // 排行榜点击
        case "village_rank":
          dotInfo.key_function = "怪兽乐园-查看排行榜";
          break;
        // 结算弹窗去商店
        case "village_gameResult_toStore":
          dotInfo.key_function = "怪兽乐园-从结算界面进入商店";
          break;
        // 用户登录时间段
        case "village_game_time":
          dotInfo.key_function = "怪兽乐园-用户游戏时间段";
          break;
        // 放弃游戏
        case "village_game_abandon":
          dotInfo.key_function = "怪兽乐园-放弃游戏";
          break;
        // 继续游戏
        case "village_game_continue":
          dotInfo.key_function = "怪兽乐园-继续游戏";
          break;
        // 通过app内返回按钮中途退出游戏
        case "villag_game_breakoff":
          dotInfo.key_function = "怪兽乐园-返回按钮中途退出游戏";
          break;
        // 2.0 end
        default:
          console.error("埋点事件未捕获！");
          break;
      }
      yoozoo.customDot(dotInfo);
    } else {
      console.error("埋点事件获取失败！");
    }
  } catch (err) {
    console.log(err);
  }
};
